import { styled } from "@mui/material/styles";

const NewUserPopupMain = styled("div")(({ theme }) => ({
  "& .closeBtn": {
    padding: "15px",
    paddingBottom: "0px",
    textAlign: "right",
    "& button": { background: "#F4F4F4", color: "#000000" },
  },
  "& .title": {
    textAlign: "center",
    "& h6": {
      fontFamily: theme.typography.fontFamily,
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20px",
      lineHeight: "27px",
      color: "#0B0B0B",
      marginTop: "-7px",
    },
  },
}));

const FormMain = styled("div")(({ theme }) => ({
  "& label": {
    fontSize: "14px",
    marginBottom: "2px",
  },
  "& input": {
    background: "#FFFFFF",
    border: "2px solid #E8E8E8",
    borderRadius: "10px",
  },
}));
const PermissionsMain = styled("div")(({ theme }) => ({
  position: "relative",
  "span.error": {
    fontFamily: "Avenir LT Std,Roboto,sans-serif",
    color: "red",
    fontWeight: 400,
    fontSize: "14px",
    position: "absolute",
    top: "100%",
    left: "0",
  },
  "&.haveError .css-di73y7-control": {
    border: "1px solid red",
  },
}));

export { NewUserPopupMain, FormMain, PermissionsMain };
